// SmsMaster.jsx
import React, { useState, useEffect, useRef } from "react";
import "../assets/SmsMaster.css";
const SmsMaster = () => {
  const [templates, setTemplates] = useState([]);
  const [formData, setFormData] = useState({
    templateName: "",
    templateId: "",
    senderId: "",
    messageId: "",
    variables: "",
    message: "",
    active: false,
    assignUser: "",
  });
  const [editingIndex, setEditingIndex] = useState(null);
  const messageRef = useRef(null);

  // Auto expand textarea as user types
  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.style.height = "auto";
      messageRef.current.style.height = messageRef.current.scrollHeight + "px";
    }
  }, [formData.message]);

  // Word count limit max 100 words
  const handleMessageChange = (e) => {
    const words = e.target.value.split(/\s+/).filter(Boolean);
    if (words.length <= 100) {
      setFormData({ ...formData, message: e.target.value });
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !formData.templateName.trim() ||
      !formData.templateId.trim() ||
      !formData.senderId.trim() ||
      !formData.messageId.trim()
    ) {
      alert("Please fill in all required fields.");
      return;
    }

    if (editingIndex !== null) {
      // Update existing
      const updatedTemplates = [...templates];
      updatedTemplates[editingIndex] = { ...formData };
      setTemplates(updatedTemplates);
      setEditingIndex(null);
    } else {
      // Add new
      setTemplates([...templates, { ...formData }]);
    }

    // Reset form
    setFormData({
      templateName: "",
      templateId: "",
      senderId: "",
      messageId: "",
      variables: "",
      message: "",
      active: false,
      assignUser: "",
    });
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setFormData(templates[index]);
  };

  const handleAssignChange = (e, index) => {
    const value = e.target.value;
    const updatedTemplates = [...templates];
    updatedTemplates[index].assignUser = value;
    setTemplates(updatedTemplates);
  };

  const handleSaveAssign = (index) => {
    alert(
      `Assign saved for template "${templates[index].templateName}": User = ${templates[index].assignUser}`
    );
  };

  return (
    <div className="SmsMaster-container">
      <section className="SmsMaster-section SmsMaster-master">
        <h2 className="SmsMaster-title-top">SMS Template Master</h2>
        <form className="SmsMaster-form" onSubmit={handleSubmit} noValidate>
          <div className="SmsMaster-row">
            <label htmlFor="templateName">Enter Template Name</label>
            <input
              id="templateName"
              name="templateName"
              type="text"
              value={formData.templateName}
              onChange={handleInputChange}
              placeholder="Template Name"
              required
              className="SmsMaster-input"
            />
          </div>

          <div className="SmsMaster-row">
            <label htmlFor="templateId">Enter Template ID</label>
            <input
              id="templateId"
              name="templateId"
              type="text"
              value={formData.templateId}
              onChange={handleInputChange}
              placeholder="Template ID"
              required
              className="SmsMaster-input"
            />
          </div>

          <div className="SmsMaster-row">
            <label htmlFor="senderId">Sender ID</label>
            <input
              id="senderId"
              name="senderId"
              type="text"
              value={formData.senderId}
              onChange={handleInputChange}
              placeholder="Sender ID"
              required
              className="SmsMaster-input"
            />
          </div>

          <div className="SmsMaster-row">
            <label htmlFor="messageId">Message ID</label>
            <input
              id="messageId"
              name="messageId"
              type="text"
              value={formData.messageId}
              onChange={handleInputChange}
              placeholder="Message ID"
              required
              className="SmsMaster-input"
            />
          </div>

          <div className="SmsMaster-row">
            <label htmlFor="variables">Variables (e.g., #var1 | #var2)</label>
            <input
              id="variables"
              name="variables"
              type="text"
              value={formData.variables}
              onChange={handleInputChange}
              placeholder="#var1 | #var2"
              className="SmsMaster-input"
            />
          </div>

          <div className="SmsMaster-row SmsMaster-message-row">
            <label htmlFor="message">Template Message (max 100 words)</label>
            <textarea
              id="message"
              name="message"
              ref={messageRef}
              value={formData.message}
              onChange={handleMessageChange}
              placeholder="Enter your message here..."
              className="SmsMaster-textarea"
              rows={1}
            />
            <small className="SmsMaster-wordcount">
              {formData.message.trim().split(/\s+/).filter(Boolean).length} / 100
              words
            </small>
          </div>

          <div className="SmsMaster-row SmsMaster-active-row">
            <label htmlFor="active">Active</label>
            <input
              id="active"
              name="active"
              type="checkbox"
              checked={formData.active}
              onChange={handleInputChange}
              className="SmsMaster-checkbox"
            />
          </div>

          <button type="submit" className="SmsMaster-submit">
            {editingIndex !== null ? "Update Template" : "Submit"}
          </button>
        </form> 
      </section>

      <section className="SmsMaster-section SmsMaster-report">
  <h2 className="SmsMaster-title">SMS Template Report</h2>
  <div className="SmsMaster-table-container">
    <table className="SmsMaster-table" role="table" aria-label="SMS Template Report">
      <thead>
        <tr>
          <th>Serial No.</th>
          <th>Template Name</th>
          <th>Template ID</th>
          <th>Sender ID</th>
          <th>Message ID</th>
          <th>Variables</th>
          <th>Message</th>
          <th>Status</th>
          <th>Edit</th>
          <th>Assign</th>
          <th>Save</th>
        </tr>
      </thead>
      <tbody>
        {templates.length === 0 ? (
          <tr className="SmsMaster-no-data-row">
            <td colSpan="11" className="SmsMaster-no-data">
              No templates added yet.
            </td>
          </tr>
        ) : (
          templates.map((tpl, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>{tpl.templateName}</td>
              <td>{tpl.templateId}</td>
              <td>{tpl.senderId}</td>
              <td>{tpl.messageId}</td>
              <td>{tpl.variables}</td>
              <td
                className="SmsMaster-message-cell"
                title={tpl.message}
              >
                {tpl.message.length > 40
                  ? tpl.message.slice(0, 37) + "..."
                  : tpl.message}
              </td>
              <td>{tpl.active ? "Active" : "Inactive"}</td>
              <td>
                <button
                  className="SmsMaster-btn-edit"
                  onClick={() => handleEdit(idx)}
                  aria-label={`Edit template ${tpl.templateName}`}
                >
                  Edit
                </button>
              </td>
              <td>
                <select
                  className="SmsMaster-select"
                  value={tpl.assignUser || ""}
                  onChange={(e) => handleAssignChange(e, idx)}
                  aria-label={`Assign user for template ${tpl.templateName}`}
                >
                  <option value="">Select</option>
                  <option value="User A">Credit account message</option>
                  <option value="User B">Debit account message</option>
                  <option value="User C">Other</option>
                </select>
              </td>
              <td>
                <button
                  className="SmsMaster-btn-save"
                  onClick={() => handleSaveAssign(idx)}
                  aria-label={`Save assignment for template ${tpl.templateName}`}
                >
                  Save
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  </div>
     </section>

    </div>
  );
};

export default SmsMaster;
